"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.useAuthDispatch = exports.useAuth = exports.AuthDispatchContext = exports.AuthContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactUse = require("react-use");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var propTypes = {
  children: _propTypes.node.isRequired,
  client: (0, _propTypes.shape)({
    reAuthenticate: _propTypes.func.isRequired,
    authenticate: _propTypes.func.isRequired,
    logout: _propTypes.func.isRequired
  }).isRequired,
  storageKey: _propTypes.string.isRequired,
  onIdle: _propTypes.func,
  idle: _propTypes.number
};
var defaultProps = {
  idle: 3e5,
  // 5m
  onIdle: null
};
var AuthContext = /*#__PURE__*/(0, _react.createContext)();
exports.AuthContext = AuthContext;
var AuthDispatchContext = /*#__PURE__*/(0, _react.createContext)();
exports.AuthDispatchContext = AuthDispatchContext;

var useAuth = function useAuth() {
  var context = (0, _react.useContext)(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within a AuthProvider');
  }

  return context;
};

exports.useAuth = useAuth;

var useAuthDispatch = function useAuthDispatch() {
  var context = (0, _react.useContext)(AuthDispatchContext);

  if (!context) {
    throw new Error('useAuthDispatch must be used within a AuthProvider');
  }

  return context;
};

exports.useAuthDispatch = useAuthDispatch;

var AuthProvider = function AuthProvider(_ref) {
  var children = _ref.children,
      client = _ref.client,
      idle = _ref.idle,
      onIdle = _ref.onIdle,
      storageKey = _ref.storageKey;
  var isIdle = (0, _reactUse.useIdle)(idle);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      user = _useState2[0],
      setUser = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      mounted = _useState4[0],
      setMount = _useState4[1];

  var context = (0, _react.useMemo)(function () {
    return {
      user: user,
      isLoggedIn: user !== null
    };
  }, [user]);
  var dispatch = (0, _react.useMemo)(function () {
    return {
      login: function login(credentials) {
        var _arguments = arguments;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _len, args, _key, response;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  for (_len = _arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = _arguments[_key];
                  }

                  _context.next = 3;
                  return client.authenticate.apply(client, [credentials].concat(args));

                case 3:
                  response = _context.sent;
                  setUser(response.user);
                  return _context.abrupt("return", response);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },
      logout: function logout() {
        var _arguments2 = arguments;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var response;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return client.logout.apply(client, _toConsumableArray(_arguments2));

                case 2:
                  response = _context2.sent;
                  setUser(null);
                  return _context2.abrupt("return", response);

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      },
      reload: function reload() {
        var _arguments3 = arguments;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          var response;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return client.reAuthenticate.apply(client, _toConsumableArray(_arguments3));

                case 2:
                  response = _context3.sent;
                  setUser(response.user);
                  return _context3.abrupt("return", response);

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      },
      setUser: setUser
    };
  }, [client]);
  var handleOnIdle = (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(onIdle && typeof onIdle === 'function')) {
              _context4.next = 5;
              break;
            }

            _context4.next = 3;
            return onIdle(dispatch.logout);

          case 3:
            _context4.next = 7;
            break;

          case 5:
            _context4.next = 7;
            return dispatch.logout();

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  })), [dispatch, onIdle]);
  var syncLogout = (0, _react.useCallback)(function () {
    if (!window.localStorage.getItem(storageKey)) {
      setUser(null);
    }
  }, [storageKey]);
  (0, _reactUse.useEvent)('storage', syncLogout);
  (0, _react.useEffect)(function () {
    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var _yield$client$reAuthe, loggedUser;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return client.reAuthenticate();

            case 3:
              _yield$client$reAuthe = _context5.sent;
              loggedUser = _yield$client$reAuthe.user;
              setUser(loggedUser);
              setMount(true);
              _context5.next = 12;
              break;

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](0);
              setMount(true);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 9]]);
    }))();
  }, [client]);
  (0, _react.useEffect)(function () {
    if (isIdle && user) {
      _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return handleOnIdle();

              case 3:
                _context6.next = 8;
                break;

              case 5:
                _context6.prev = 5;
                _context6.t0 = _context6["catch"](0);
                setUser(null);

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 5]]);
      }))();
    }
  }, [isIdle, user, client, handleOnIdle]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(AuthContext.Provider, {
    value: context,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AuthDispatchContext.Provider, {
      value: dispatch,
      children: mounted ? children : null
    })
  });
};

AuthProvider.propTypes = propTypes;
AuthProvider.defaultProps = defaultProps;
var _default = AuthProvider;
exports["default"] = _default;

//# sourceMappingURL=AuthContext.js.map